import Vue from 'vue'
import Router from 'vue-router' 

Vue.use(Router)

export default new Router({
  strict: true,
  bmode: 'hash', 
  routes: [
    {
      path: '/',
      component: () => import('@/views/landing/Login'),
    },
    {
      path: '/forgot_password',
      component: () => import('@/views/landing/Forgot_pass'),
    }, 
    {
      path: '*',
      component: () => import('@/views/account/Sorry'),
    },
    {
      // meta: {
      //   requiresAuth: true,
      // },
      path: '/ntsa',
      name: 'NTSA',
      component: () => import('@/views/Ntsa'),
    },
    {
      meta: {
        requiresAuth: true,
      },
      path: '/account',
      name: 'Home',
      redirect: '/account/home',
      component: () => import('@/views/Platform'),
      children: [
        {
          name: 'Assets',
          path: '/account/home',
          component: () => import('@/views/account/Home'),
        },
        {
          name: 'Maps',
          path: '/account/dashboard',
          component: () => import('@/views/account/Dashboard'),
        }, 
        // {
        //   name: 'Google Maps',
        //   path: '/account/dashboard_gmaps',
        //   component: () => import('@/views/account/Dashboardgoogle'),
        // },
        {
          name: 'Asset Info.',
          path: '/account/asset_info',
          component: () => import('@/views/account/Asset_info'),
        },
        {
          name: 'Trips',
          path: '/account/trips',
          component: () => import('@/views/account/Trips'),
        },
        {
          name: 'Alerts',
          path: '/account/alerts',
          component: () => import('@/views/account/Alerts'),
        },
        {
          name: 'Playback',
          path: '/account/playback',
          component: () => import('@/views/account/Playback'),
        }, 
        {
          name: 'Reports',
          path: '/account/reports',
          component: () => import('@/views/account/Reports'),
        }, 
        {
          path: '/account/changepassword',
          component: () => import('@/views/account/Change_password'),
        }, 
        {
          path: '/account/governors_management',
          component: () => import('@/views/account/Meta_data'),
        }, 
        {
          name: 'EventDetail',
          path: '/account/EventDetail',
          component: () => import('@/views/account/EventDetail'),
        },
      ],
    },
  ],
})

